import {inject, signal} from '@angular/core';
import {switchMap, catchError} from 'rxjs/operators';
import {of} from 'rxjs';
import {ExternalpageService, externalpageTypes, externalpageImageTypes} from '../shared/services/externalpage.service';
import {DomainService} from '../shared/services/domain.service';
import {TargetGroupService} from '../shared/services/target-group.service';

export class ExternalpageOverview {

  externalpageTypes = externalpageTypes;
  externalpageImageTypes = externalpageImageTypes;

  protected targetGroupService = inject(TargetGroupService);

  /** Signal-based loading state — works with OnPush change detection */
  isLoading = signal(false);

  view = {
    pageType: externalpageTypes.Generic,
    queryParams: {
      pageSize: 8,
      pageNumber: 1,
      totalItems: 0
    },
    data: <any[]> [],
  }

  /**
   * Constructor
   *
   * @param externalpageService
   */
  constructor(
    public externalpageService: ExternalpageService,
    protected domain: DomainService
  ) {


  }

  /**
   * Load view data
   */
  loadData() {

    this.isLoading.set(true);

    this.targetGroupService.getDefaultTargetGroups$('externalpage').pipe(
      switchMap(targetGroups => {
        const targetGroup = targetGroups?.[0] ?? null;
        return this.externalpageService.apiGetExternalPageType(this.view.pageType, this.view.queryParams, this.domain.getCurrentRegion(), targetGroup);
      }),
      catchError((err) => {
        console.error('Failed to load data:', err);
        return of(null);
      })
    ).subscribe( (response: any) => {

      this.isLoading.set(false);

      if (!response) return;

      if (response.hasOwnProperty('totalItems')) {
        this.view.queryParams.totalItems = response.totalItems;
      }
      if (response.hasOwnProperty('data')) {

        this.view.data = Object.assign([], response.data);

        if (this.view.data.length > 0) {

          for (const i in this.view.data) {

            if (this.view.data[i]['imageReferences'].length > 0) {
              for (const image of this.view.data[i]['imageReferences']) {
                if (image['imageType'] == this.externalpageImageTypes.MainImage) {
                  this.view.data[i]['imageUri'] = image['imageUri'];
                }
              }
            }
          }
        }
      }
    });
  }

  /**
   * Set current page number
   *
   * @param $page
   */
  setPage($page: number) {
    this.view.queryParams.pageNumber = $page;
    this.loadData();
  }

}
